export default "__VITE_ASSET__D4F8mMAw__"